module.exports = __webpack_public_path__ + "media/application/images/section_images/technology-aa5aca570722f277b5994abfd553fd2e.jpg";